import { render } from "./SortTableComponent.vue?vue&type=template&id=e242920e&scoped=true"
import script from "./SortTableComponent.vue?vue&type=script&lang=js"
export * from "./SortTableComponent.vue?vue&type=script&lang=js"

import "./SortTableComponent.vue?vue&type=style&index=0&id=e242920e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e242920e"]])

export default __exports__